export default "__VITE_ASSET__b3fd63e4__"